function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityGymFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.692 19.195a1.154 1.154 0 01-2.307 0v-6.39a1.154 1.154 0 012.307 0v6.39zm-4.615 2.307a1.154 1.154 0 01-2.308 0V10.498a1.154 1.154 0 012.308 0v11.004zm-13.846 0a1.154 1.154 0 01-2.308 0V10.498a1.154 1.154 0 012.308 0v11.004zm-5.77-1.154a1.154 1.154 0 01-1.153-1.153v-6.39a1.154 1.154 0 012.307 0v6.39c0 .636-.517 1.153-1.153 1.153zM27.54 9.344c-.456 0-.89.094-1.288.255-.4-1.472-1.732-2.563-3.328-2.563a3.466 3.466 0 00-3.461 3.462v4.348h-6.924v-4.348a3.466 3.466 0 00-3.461-3.462c-1.596 0-2.929 1.09-3.328 2.562a3.438 3.438 0 00-1.287-.254A3.466 3.466 0 001 12.806v6.389a3.466 3.466 0 003.462 3.461c.455 0 .89-.093 1.287-.255.4 1.472 1.732 2.563 3.328 2.563a3.466 3.466 0 003.461-3.462v-4.349h6.924v4.35a3.466 3.466 0 003.461 3.46c1.596 0 2.929-1.09 3.328-2.562.398.162.832.255 1.287.255A3.466 3.466 0 0031 19.195v-6.39a3.466 3.466 0 00-3.462-3.46z",
    fill: props.color
  }));
}

export default SvgIconFacilityGymFilled;